import {
  Configuration,
  TenantApi,
  WeappApi,
  WxApi,
  WeappTplApi,
  WxTplApi,
  DeviceApi,
  StoreApi,
  AdminApi,
  FacilitatorApi,
  HomeApi,
  DistanceApi,
  RecordApi,
  WhiteAccountApi,
  UploadApi,
  AdvertisingApi,
  StationTypeApi,
  ExpressCompanyApi,
  PackageApi,
  MemberApi,
  RechargePlanApi,
  TicketPackageApi,
  TicketApi,
  IncentivePlanApi,
  AibeanApi,
  AiBeanRecordApi,
  StoreStatisticsApi,
  JumpWeappApi,
} from '@/api';
import { BusinessMenuApi } from '@/api/businessMenu';
import { BusinessRoleApi } from '@/api/businessRole';
import { AdminDeviceAuthApi } from '@/api/adminDeviceAuth';
import { axios } from 'hpsfir-managebase-ui';

interface BaseApi {
  baseUrl: string;
  uploadImageUrl: string;
  tenantApi: TenantApi;
  weappApi: WeappApi;
  wxApi: WxApi;
  weappTplApi: WeappTplApi;
  wxTplApi: WxTplApi;
  deviceApi: DeviceApi;
  storeApi: StoreApi;
  adminApi: AdminApi;
  facilitatorApi: FacilitatorApi;
  homeApi: HomeApi;
  distanceApi: DistanceApi;
  recordApi: RecordApi;
  whiteAccountApi: WhiteAccountApi;
  uploadApi: UploadApi;
  advertisingApi: AdvertisingApi;
  stationTypeApi: StationTypeApi;
  expressCompanyApi: ExpressCompanyApi;
  packageApi: PackageApi;
  memberApi: MemberApi;
  rechargePlanApi: RechargePlanApi;
  ticketPackageApi: TicketPackageApi;
  ticketApi: TicketApi;
  incentivePlanApi: IncentivePlanApi;
  aibeanApi: AibeanApi;
  aiBeanRecordApi: AiBeanRecordApi;
  storeStatisticsApi: StoreStatisticsApi;
  jumpWeappApi: JumpWeappApi;
  businessMenuApi: BusinessMenuApi;
  businessRoleApi: BusinessRoleApi;
  adminDeviceAuthApi: AdminDeviceAuthApi;
}

const api: BaseApi = {

} as any;

export const initApi = (basePath: string) => {
  const apiConfig = new Configuration({
    basePath,
  });
  api.baseUrl = basePath;
  api.uploadImageUrl = '/upload/image';
  api.tenantApi = new TenantApi(apiConfig, basePath, axios);
  api.weappApi = new WeappApi(apiConfig, basePath, axios);
  api.wxApi = new WxApi(apiConfig, basePath, axios);
  api.weappTplApi = new WeappTplApi(apiConfig, basePath, axios);
  api.wxTplApi = new WxTplApi(apiConfig, basePath, axios);
  api.deviceApi = new DeviceApi(apiConfig, basePath, axios);
  api.storeApi = new StoreApi(apiConfig, basePath, axios);
  api.adminApi = new AdminApi(apiConfig, basePath, axios);
  api.facilitatorApi = new FacilitatorApi(apiConfig, basePath, axios);
  api.homeApi = new HomeApi(apiConfig, basePath, axios);
  api.distanceApi = new DistanceApi(apiConfig, basePath, axios);
  api.recordApi = new RecordApi(apiConfig, basePath, axios);
  api.uploadApi = new UploadApi(apiConfig, basePath, axios);
  api.advertisingApi = new AdvertisingApi(apiConfig, basePath, axios);
  api.stationTypeApi = new StationTypeApi(apiConfig, basePath, axios);
  api.expressCompanyApi = new ExpressCompanyApi(apiConfig, basePath, axios);
  api.packageApi = new PackageApi(apiConfig, basePath, axios);
  api.memberApi = new MemberApi(apiConfig, basePath, axios);
  api.rechargePlanApi = new RechargePlanApi(apiConfig, basePath, axios);
  api.ticketPackageApi = new TicketPackageApi(apiConfig, basePath, axios);
  api.ticketApi = new TicketApi(apiConfig, basePath, axios);
  api.incentivePlanApi = new IncentivePlanApi(apiConfig, basePath, axios);
  api.aibeanApi = new AibeanApi(apiConfig, basePath, axios);
  api.aiBeanRecordApi = new AiBeanRecordApi(apiConfig, basePath, axios);
  api.storeStatisticsApi = new StoreStatisticsApi(apiConfig, basePath, axios);
  api.jumpWeappApi = new JumpWeappApi(apiConfig, basePath, axios);
  api.businessMenuApi = new BusinessMenuApi(apiConfig, basePath, axios);
  api.businessRoleApi = new BusinessRoleApi(apiConfig, basePath, axios);
  api.adminDeviceAuthApi = new AdminDeviceAuthApi(apiConfig, basePath, axios);
};

export const useApi = () => api;

